<template>
    <div class="bet-offer-wrapper">
      <div class="bet-offer-header-info">
        <div class="match-id">{{selected.match.matchDisplayId}}</div>
        <div class="game-icon">
          <i class="n-i" :class="[getIcon]"></i>
        </div>
        <div class="match-name">{{selected.match.matchName}}</div>
        <div class="match-time">{{selected.match.matchDateTimeUTC | formatDate}}</div>
      </div>
      <div class="bet-offer-main">
        <div data-simplebar>
          <div class="simplebar-scroll-content">
            <div class="simplebar-content">
              <table>
                <tbody>
                <tr v-for="(row, index) of filteredOffer"
                    :key="index">
                  <td v-for="(bet, betIndex) of row"
                      :key="betIndex">
                    <div class="bet-offer-wrapper">
                      <div class="bet-offer-header"
                           :class="{'selected': bet.idBet == selected.bet.idBet}">
                        <span class="bet-offer-display-id">{{bet.betDisplayId}}</span>
                        <span class="bet-offer-name">{{bet.betName}}
                          {{ bet.betSpecialValue ? bet.betSpecialValue : ''}}</span>
                      </div>
                      <div class="bet-offer-content">
                        <div class="bet-offer-outcome clearfix"
                             v-for="(outcome, outcomeIndex) of bet.betOutcomes"
                             :key="outcomeIndex"
                             :class="{'reduce-width': bet.betOutcomes.length > 5,
                             'active': setActiveStyle(outcome, bet.betDisplayId),
                             'selected': outcome.outcomeId == selected.outcome.outcomeId}"
                             @click="validatePreBetslip(bet, outcome)">
                          <div class="bet-offer-outcome-name overflow-text pull-left"
                               :class="windowType">
                            {{outcome.outcomeShortName}}</div>
                          <div class="pull-right bet-offer-outcome-odd"
                               :class="windowType">
                            {{outcome.outcomeOdd}}</div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import toNumber from 'lodash/toNumber';
import findIndex from 'lodash/findIndex';
import * as Ticket from '@/model/ticket';

export default {
  name: 'BetOfferBox',
  data() {
    return {
      filteredOffer: [],
      searchedBet: [],
      windowType: 'default',
    };
  },
  computed: {
    ...mapGetters([
      'bets',
      'offer',
      'getIcon',
      'selected',
      'searchedValue',
      'activeBetType',
      'editBet',
      'gameConfig',
      'translations',
      'getActiveBetsFromBetslip',
    ]),
  },
  methods: {
    ...mapActions([
      'updateSelected',
      'setSearchedValue',
      'setSearchInputActive',
      'goHome',
      'clearSelected',
      'addBet',
      'changeBet',
      'sendMessage',
    ]),
    setActiveStyle(outcome, betId) {
      return findIndex(this.getActiveBetsFromBetslip, bet => bet.betDisplayId === betId
        && bet.betOutcomeShortcut.toString() === outcome.outcomeShortcut.toString()) >= 0;
    },
    /**
     * Find all bets for selected match
     */
    setFilteredOffer() {
      this.filteredOffer = [];
      const numbRows = Math.ceil(this.searchedBet.length / 3);
      const numbCol = 3;
      let i = 0;
      while (i < numbRows) {
        const start = i * numbCol;
        const end = (i + 1) * numbCol;
        const tempArray = this.searchedBet.slice(start, end);
        this.filteredOffer.push(tempArray);
        i += 1;
      }
    },
    /**
     * Search bets by bet id and name
     *
     * @param {object} data
     */
    searchBet(data) {
      this.searchedBet = [];
      const { matchBets } = this.selected.match;
      const newBets = [];
      const value = toNumber(data);
      let i = 0;
      let index;
      while (i < matchBets.length && data) {
        if (!Number.isNaN(value)) {
          const idToString = matchBets[i].betDisplayId.toString();
          index = idToString.indexOf(value);
          if (index >= 0) {
            newBets.push(matchBets[i]);
          }
        } else {
          index = (matchBets[i].betName.toLowerCase()).indexOf(data.toLowerCase());
          if (index >= 0) {
            newBets.push(matchBets[i]);
          }
        }
        i += 1;
      }
      this.searchedBet = newBets.length ? newBets : matchBets;
    },
    /**
     * Check is selected match already on betslip
     *
     * @param {object} bet
     * @param {object} outcome
     * @return {number}
     */
    findMatchInBetslip(bet, outcome) {
      let findMatch = -1;
      let index = null;
      if (this.activeBetType === 'combo') {
        index = findIndex(this.bets, ticketBet => ticketBet.idMatch === bet.idMatch);
      } else {
        index = findIndex(
          this.bets,
          ticketBet => ticketBet.idMatch === bet.idMatch
            && ticketBet.betDisplayId === bet.betDisplayId
            && ticketBet.betOutcomeShortcut === outcome.outcomeShortcut,
        );
      }
      findMatch = index;
      return findMatch;
    },
    toggleBet(index, outcome) {
      let isDifferentBet = true;
      if (this.bets.length && this.bets[index].betOutcomeShortcut === outcome.outcomeShortcut) {
        this.$store.commit('REMOVE_BET', index);
        isDifferentBet = false;
      }
      return isDifferentBet;
    },
    // Need refactoring
    /**
     * Data validation before sending to betslip
     *
     * @param {object} bet
     * @param {object} outcome
     */
    validatePreBetslip(bet, outcome) {
      const isEditBet = Object.prototype.hasOwnProperty.call(this.editBet, 'index');
      const haveInBetslip = this.findMatchInBetslip(bet, outcome);
      const isDifferentBet = isEditBet || haveInBetslip < 0
        ? true : this.toggleBet(haveInBetslip, outcome);
      const isValid = Object.prototype.hasOwnProperty.call(this.offer, bet.idMatch)
        && this.validateBet(bet.idBet)
        && this.validateOutcome(bet.betOutcomes, outcome.outcomeId)
      && isDifferentBet;
      let finalBet;
      // Check if bet is valid
      if (isValid) {
        finalBet = new Ticket.Bet(this.selected.match, bet, outcome);
        if (isEditBet || (this.activeBetType === 'combo' && haveInBetslip >= 0)) {
          const editBet = {
            data: finalBet,
            index: this.editBet.index >= 0 ? this.editBet.index : haveInBetslip,
          };
          this.changeBet(editBet);
        } else if (haveInBetslip < 0) {
          // Check rule for max number of bets on betslip
          if (this.bets.length >= this.gameConfig.rules_maxBetCount) {
            const errorMessage = this.translations.maxNumBet || 'maxNumBet';
            const error = {
              action: 'Dialog.ShowModal',
              data: {
                action: '7S:Dialog.ShowModal',
                message: `${errorMessage} ${this.gameConfig.rules_maxBetCount}.`,
                type: 'warning',
                delay: 3000,
              },
            };
            this.sendMessage(error);
          } else {
            // Send data to betslip
            this.addBet(finalBet);
          }
        }
        this.clearSelected();
        this.goHome(this.$router);
      }
    },
    /**
     * Validate selected bet
     * @param {number} betId
     * @returns {number}
     */
    validateBet(betId) {
      const index = findIndex(this.selected.match.matchBets, bet => bet.idBet === betId);
      return index >= 0;
    },
    /**
     * Validate selected outcome
     * @param {object} outcomes
     * @param {string} outcomeId
     */
    validateOutcome(outcomes, outcomeId) {
      const index = findIndex(outcomes, outcome => outcome.outcomeId === outcomeId);
      return index >= 0;
    },
    searchWindowType() {
      let type = 'small';
      switch (true) {
        case (window.innerWidth >= 1600):
          type = 'large';
          break;
        case (window.innerWidth >= 1378):
          type = 'medium';
          break;
        // no default
      }
      this.windowType = type;
    },
  },
  mounted() {
    this.searchWindowType();
    this.$nextTick(() => {
      window.addEventListener('resize', this.searchWindowType);
    });
    this.searchedBet = this.selected.match.matchBets;
    this.setSearchedValue('');
    this.setSearchInputActive();
    this.setFilteredOffer();
  },
  watch: {
    searchedValue: {
      handler(newValue) {
        this.searchBet(newValue);
        this.setFilteredOffer();
      },
    },
    offer: {
      handler(newValue) {
        const isValid = Object.prototype.hasOwnProperty.call(newValue, this.selected.match.idMatch);
        if (!isValid) {
          this.goHome(this.$router);
        }
      },
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.searchWindowType);
  },
};
</script>

<style lang="scss" scoped>
  .bet-offer-wrapper {
    height: 100%;
    overflow: hidden;
    .bet-offer-header {
      height: 35px;
      line-height: 35px;
    }
  }
  .bet-offer-header-info {
    background-color: #2e3743;
    color: #fff;
    font-size: 12px;
    margin: 10px 0;
    padding-left: 10px;
    >div {
      display: inline-block;
      padding-right: 10px;
    }
  }
  .bet-offer-main {
    color: #455a64;
    height: calc(100% - 35px);
    width: 100%;
    table {
      border-collapse: separate;
      border-spacing: 5px 1px;
      width: 100%;
      tr {
        vertical-align: top;
      }
      td {
        background: #fff;
        width: calc(100% / 3);
        .bet-offer-wrapper {
          border: 1px solid #e0e3e4;
          .bet-offer-header {
            background: #f2f5f7;
            font-size: 12px;
            padding: 5px 10px;
            &.selected {
              background: #000;
              color: #fff;
            }
            span {
              &.bet-offer-display-id {
                padding-right: 5px;
              }
            }
          }
          .bet-offer-content {
            padding: 5px;
            .bet-offer-outcome {
              border: 1px solid #e0e3e4;
              cursor: pointer;
              display: inline-block;
              font-size: 12px;
              margin: 3px 0;
              padding: 0 10px;
              position: relative;
              width: 100%;
              &.reduce-width {
                width: 50%;
              }
              &.active {
                background-color: #ccc !important;
                color: #fff !important;
              }
              &.selected {
                background-color: #5daf64 !important;
                color: #fff !important;
              }
              .bet-offer-outcome-name {
                width: 70%;
                padding-right: 10px;
                &:hover {
                  overflow: visible;
                  white-space: normal;
                }
                &.small {
                  width: 60% !important;
                }
                &.medium {
                  width: 70% !important;
                }
                &.large {
                  width: 75% !important;
                }
              }
              .bet-offer-outcome-odd {
                padding-right: 5px;
                text-align: right;
                width: 30%;
                &.small {
                  width: 40% !important;
                }
                &.medium {
                  width: 30% !important;
                }
                &.large {
                  width: 25% !important;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
